package app.nestbridge.app.ui

import com.karawek.core.auth.screen.OtpVerificationScreen
import com.karawek.core.auth.screen.OtpVerificationState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class OtpVerificationUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is OtpVerificationScreen -> ui<OtpVerificationState> { state, modifier -> OtpVerificationUi(state = state, modifier = modifier) }
    else -> null
  }
}
